import { createSlice } from "@reduxjs/toolkit"

const defaultValuesSlice = createSlice({
   name: "defaultValues",
   initialState: {
      defaultValues: null,
      getDefaultValueLoading: false,
      updateDefaultValueLoading: false,
      updateDefaultValueError: null
   },
   reducers: {
      getDefaultValueLoading: (state) => {
         state.getDefaultValueLoading = true
      },
      getDefaultValueSuccess: (state, action) => {
         state.defaultValues = action.payload
         state.getDefaultValueLoading = false
      },
      getDefaultValueFailure: (state) => {
         state.getDefaultValueLoading = false
      },
      updateDefaultValueLoading: (state) => {
         state.updateDefaultValueLoading = true
         state.updateDefaultValueError = null
      },
      updateDefaultValueSuccess: (state, action) => {
         state.defaultValues = action.payload
         state.updateDefaultValueLoading = false
         state.updateDefaultValueError = null
      },
      updateDefaultValueFailure: (state, action) => {
         state.updateDefaultValueLoading = false
         state.updateDefaultValueError = action.payload
      }
   }
})

export const {
   getDefaultValueLoading,
   getDefaultValueSuccess,
   getDefaultValueFailure,
   updateDefaultValueLoading,
   updateDefaultValueSuccess,
   updateDefaultValueFailure
} = defaultValuesSlice.actions

export default defaultValuesSlice.reducer